/** @jsx jsx */
import { jsx, Box, Styled } from "theme-ui"
import { alpha } from "@theme-ui/color"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import { Container, Row, Col } from "components/layout"

const SupportingEachotherHeroOneFr = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "supporting-eachother-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box sx={{ mt: -4 }}>
      <BackgroundImage
        tag="div"
        fluid={data.hero.childImageSharp.fluid}
        backgroundColor="#fff"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: ["center", "center right"],
        }}
      >
        <Box
          sx={{
            backgroundColor: [
              alpha("secondary", 0.9),
              alpha("secondary", 0.9),
              alpha("secondary", 0),
            ],
            backgroundImage: [
              "none",
              "linear-gradient(to right, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.95) 40%, rgba(0,0,0,0) 65%)",
            ],
            color: "background",
            py: 4,
            width: "100%",
          }}
        >
          <Container wide>
            <Row>
              <Col sx={{ width: ["100%", "70%", "50%"] }}>
                <Styled.h1 sx={{ color: "background" }}>
                  Salut type 1, tu ne pourras pas nous arrêter
                </Styled.h1>
                <Styled.p>Salut type 1,</Styled.p>
                <Styled.p>
                  Tu es entré dans ma vie il y a presque trois ans. Ce ne fut
                  pas facile, mais j’apprends à vivre avec toi. Ma mère, Hélène,
                  dit que je suis résilient. Je suppose qu’elle a raison. Tu ne
                  m’as pas donné le choix de continuer à me battre, pour moi et
                  pour les autres. C’est là que vont toutes mes énergies.
                </Styled.p>
                <Styled.p sx={{ fontWeight: "bold" }}>
                  Je me souviens du jour où j’ai reçu le diagnostic.
                </Styled.p>
                <Styled.p>
                  Ce fut un choc pour moi et encore plus pour ma famille. Ma
                  mère en parle encore aujourd’hui avec beaucoup d’émotions.
                  Elle a remarqué que j’étais très fatigué et que j’avais
                  toujours soif. Elle a constaté, lorsqu’elle me donnait des
                  câlins, que je perdais du poids. Mais j’étais un jeune garçon
                  de 12 ans en croissance qui était sur le point d’entrer dans
                  l’adolescence. Comme la plupart des parents, les miens ont
                  pensé que ces changements étaient normaux.
                </Styled.p>
                <Styled.p>
                  Ma mère voulait cependant en être certaine. Alors elle a
                  demandé à un pharmacien de vérifier mon taux de glycémie. Et
                  subitement, je me suis retrouvé à l’urgence de l’hôpital où
                  j’ai reçu un diagnostic qui allait changer ma vie.
                </Styled.p>
              </Col>
            </Row>
          </Container>
        </Box>
      </BackgroundImage>
    </Box>
  )
}

export default SupportingEachotherHeroOneFr
